import classnames from 'classnames';
import React, { useState } from 'react';
import styled from 'styled-components';

import RefinementNestedMenu from '@search/RefinementNestedMenu';
import { mediaQueries } from '@general/breakpoints';

const RefinementContainer = styled.div`
    padding-top: 0.5rem;
    padding-bottom: 0.5rem;
    width: 100% !important;
    z-index: 100;

    @media ${mediaQueries.md} {
        width: 340px !important;
    }

    @media ${mediaQueries.lg} {
        width: 280px !important;
    }

    @media ${mediaQueries.xl} {
        width: 215px !important;
    }

    &.isOpen {
        z-index: 200;
    }

    &:not(:last-of-type) {
        margin-right: 1rem;
    }
`;

const SearchRefinementsExhibitors = () => {
    const [openMenu, setOpenMenu] = useState(null);

    return (
        <div className="d-flex flex-wrap">
            {/*
            Ideally this would use a Hierarchical Menu, but the Algolia facet field was set up a
            certain way to allow for multiple selections on the global search, so we have to work
            with what we have.
            */}
            <RefinementContainer className={classnames({ isOpen: openMenu === 'businessType' })}>
                <RefinementNestedMenu
                    attribute="business_type"
                    placeholder="Business Type"
                    showMore={false}
                    onMenuOpen={() => {
                        setOpenMenu('businessType');
                    }}
                />
            </RefinementContainer>
        </div>
    );
};

export default SearchRefinementsExhibitors;
